<template>
    <Top></Top>
    <div class="d-flex flex-column align-items-center">
        <img class="img-fluid mb-5" src="/Images/product_western_top.jpg" alt="">
        <h3 class="mb-3">西式禮儀</h3>
        <!-- <img class="img-fluid mb-3"
            src="https://storage.googleapis.com/upage/5ad02958e65f35001d1dc36f/2020/02/25/7712bf2b89ecdec01716dc7ae2347ff4.jpg"
            alt=""> -->
    </div>


    <div class="d-flex justify-content-center flex-wrap bg-secondary  myBorder">

        <div class="card m-3 w-md-20 w-100">
            <div class="card-body">
                <h5 class="card-title">圓滿</h5>
                <p class="card-text">費用：168,000</p>
                <p>　</p>
                <a href="圓滿-西式.pdf"  target="_blank" class="btn btn-primary">詳細</a>
            </div>
        </div>

        <div class="card m-3 w-md-20 w-100">
            <div class="card-body">
                <h5 class="card-title">真情</h5>
                <p class="card-text">費用：128,000</p>
                <p>　</p>
                <a href="真情-西式.pdf" target="_blank" class="btn btn-primary">詳細</a>
            </div>
        </div>

        <div class="card m-3 w-md-20 w-100">
            <div class="card-body">
                <h5 class="card-title">簡愛</h5>
                <p class="card-text">費用：98,000</p>
                <p>　</p>
                <a href="簡愛-西式.pdf" target="_blank" class="btn btn-primary">詳細</a>
            </div>
        </div>        

        <div class="card m-3 w-md-20 w-100">
            <div class="card-body">
                <h5 class="card-title">直接火化</h5>
                <p class="card-text">費用：58,000</p>
                <p>　</p>
                <a href="直接火化-西式.pdf" target="_blank" class="btn btn-primary">詳細</a>
            </div>
        </div>

        <div class="card m-3 w-md-20 w-100">
            <div class="card-body">
                <h5 class="card-title">聯合奠祭</h5>
                <p class="card-text">費用：38,000</p>
                <p>依各縣市聯合奠祭規定辦理</p>
                <a href="javascript:void(0)" @click="btnCall()" class="btn btn-primary">詳細</a>
            </div>
        </div>     

    </div>

    <Bottom></Bottom>


</template>

<script>
    import Top from '../components/Top.vue'
    import Bottom from '../components/Bottom.vue'
    export default {
        data() {
            return {

            }
        },
        components: {
            Top,
            Bottom
        },
        methods: {
            btnCall(){
                alert("請洽：0916811006 李小姐");
            }
        },

    }
</script>